import React from "react";
import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Tooltip } from "recharts";
import { toNumber } from "../utils/chartTransforms";

const StatusEtapasRadar = ({ data = [], height = 400, color = "#d9534f" }) => {
  const series = data.map((d) => ({ ...d, value: toNumber(d.value) }));
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RadarChart data={series}>
        <PolarGrid />
        <PolarAngleAxis dataKey="name" />
        <PolarRadiusAxis />
        <Radar name="Etapas" dataKey="value" stroke={color} fill={color} fillOpacity={0.6} />
        <Tooltip />
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default StatusEtapasRadar;
